/**
 * Where the public Eevo API lives on Eevo's host: under `/api`, with no product name in the path (the
 * host names it). The same routes still answer under `/api/arvo`, their paths from before the Eevo
 * name, for callers that use them (PLT-7564). Console, MCP and OAuth routes stay under `/api/arvo`:
 * they are not part of this split.
 */
export const EEVO_API_PATH_PREFIX = '/api';
export const LEGACY_ARVO_API_PATH_PREFIX = '/api/arvo';

/** The OpenAPI document, under either prefix. */
export const EEVO_OPENAPI_SUBPATH = '/openapi.json';
export const EEVO_OPENAPI_PATH = `${EEVO_API_PATH_PREFIX}${EEVO_OPENAPI_SUBPATH}`;

/**
 * The public API's resources under `/api/v1`. Named one by one, not the whole of `/api/v1/`, as the
 * platform has routes there too (`/api/v1/company-profiles`).
 */
const EEVO_API_V1_RESOURCES = ['decisions', 'systemone'] as const;

/** A public API path (`/v1/decisions`, …) as callers are told to use it. */
export function eevoApiPath(subpath: string): string {
  return `${EEVO_API_PATH_PREFIX}${subpath}`;
}

/** Whether `path` is under one of the public API's `/api/v1` resources (not their `/api/arvo/v1` form). */
export function isEevoApiV1Path(path: string): boolean {
  return EEVO_API_V1_RESOURCES.some(resource => {
    const base = `${EEVO_API_PATH_PREFIX}/v1/${resource}`;
    return path === base || path.startsWith(`${base}/`);
  });
}
